import { Box, Slider, styled, Typography } from '@mui/material';
import dayjs from 'dayjs';
import Icon from '../../Assets/Icon/CustomIcon';
import 'dayjs/locale/ko';

const CustomSlider = styled(Slider)(({ height }) => ({
  height,
  borderRadius: 20,
  padding: 0,
  '& .MuiSlider-track': {
    backgroundColor: '#FFB41B',
    border: 'none',
    borderRadius: 20,
  },
  '& .MuiSlider-rail': {
    backgroundColor: '#FFB41B40',
    borderRadius: 20,
  },
  '& .MuiSlider-thumb': {
    display: 'none',
  },
}));

const formatTime = (seconds) => {
  const m = String(Math.floor(seconds / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${m} : ${s}`;
};

export default function ProgressBarDefault({
  current,
  duration,
  showIssuanceNotice = false,
}) {
  const currentMonthName = dayjs().format('MMMM');
  dayjs.locale('ko');
  const maxPer = duration > 0 ? Math.floor((current / duration) * 100) : 0;
  const currentPer = Math.min(100, Math.round((current / 12000) * 100));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '8px',
      }}
    >
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: '700',
        }}
      >
        {currentMonthName} 진행 상황
      </Typography>
      <Box sx={{ position: 'relative', height: 20 }}>
        <CustomSlider
          value={currentPer}
          max={duration}
          height={20}
          sx={{
            position: 'absolute',
            width: '100%',
            top: '50%',
            transform: 'translateY(-50%)',
            padding: 0,
          }}
          disabled
        />
        <Typography
          sx={{
            position: 'absolute',
            width: '100%',
            top: '50%',
            transform: 'translateY(-50%)',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#000000',
            textShadow: `
                    -0.7px -0.7px 0 #FFFFFF,  
                     0.7px -0.7px 0 #FFFFFF,
                    -0.7px  0.7px 0 #FFFFFF,
                     0.7px  0.7px 0 #FFFFFF
                  `,
          }}
        >
          {/* {formatTime(current)} */}
          {currentPer}%
        </Typography>
      </Box>

      {showIssuanceNotice && (
        <Box sx={{ fontSize: '16px' }}>
          <Typography sx={{ lineHeight: '20px' }}>
            총{' '}
            <span style={{ fontWeight: 'bold', color: '#00789E' }}>200분</span>{' '}
            중{' '}
            <span style={{ fontWeight: 'bold', color: '#FFB41B' }}>700분</span>{' '}
            이수 완료하였습니다. TBM 이수까지{' '}
            <span style={{ fontWeight: 'bold' }}>2000분</span> 남았습니다.
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export function ProgressBarAdmin({ current, duration }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '6px',
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: '700',
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          color: '#6F6F6F',
        }}
      >
        <Icon.Time />
        현재 교육 진행 시간
      </Typography>
      <Typography
        sx={{
          width: '100%',
          textAlign: 'center',
          fontSize: '20px',
          fontWeight: 'bold',
          color: '#3A3A3A',
        }}
      >
        {formatTime(current)}
      </Typography>
      <CustomSlider
        value={current}
        max={duration}
        height={10}
        sx={{
          width: '100%',
        }}
        style={{ padding: 0 }}
        disabled
      />
    </Box>
  );
}
